/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import AddressModel from '@/api/address/address.model';
import { formatAddressSingleLine } from '@/modules/main/utils/address';

/**
 * Component.
 */
@Component({
  name: 'processing-info-component'
})
export default class extends Vue {
  /**
   * Property `address`.
   */
  @Prop({ type: Object })
  deliveryAddress: AddressModel;

  /**
   * Getter `addressFormatted`.
   */
  get addressFormatted() {
    return formatAddressSingleLine({ address: this.deliveryAddress });
  }
}
